let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6kz39")).then(() => parcelRequire('bExYt'));